import React from "react";

import { copy } from "shared/assets";
import { CenterContent, Icon, MutedText } from "shared/styles";
import { Title, Card } from "shared/components";
import { Spacer } from "shared/layout";
import { Error } from "shared/assets/icons";
import { colors } from "shared/styles/constants";

export const PageError: React.FC = () => {
  return (
    <CenterContent verticalMargin="xl">
      <Card>
        <Spacer size="m">
          <Spacer
            size="s"
            spaceDirection="horizontal"
            align="center"
            flexWrap="nowrap"
          >
            <Icon as={Error} size="xxxl" color={colors.red} />
            <Title title={copy.errorPage.title} />
          </Spacer>
          <MutedText>{copy.errorPage.detail}</MutedText>
        </Spacer>
      </Card>
    </CenterContent>
  );
};
